const companyLocalStorageId = () => {
  return Number(localStorage.getItem("company_id"));
};
export default companyLocalStorageId;